<template>
  <el-menu active-text-color="#1B994F" unique-opened :default-active="active">
    <el-submenu
      popper-class="submenu"
      v-for="(item, index) in items"
      :index="item.code"
      :key="index"
    >
      <template slot="title">
        <span>{{item.name}}<i class="count">({{item.count}})</i></span>
      </template>
      <el-submenu
        :index="item.code"
        v-for="(item, index) in item.children"
        :key="index"
        v-if="type === 'product'"
      >
        <template slot="title">
          <span>{{item.name}}<i class="count">({{item.count}})</i></span>
        </template>
        <el-menu-item
            :index="item.code"
            v-for="(item, index) in item.children"
            :key="index"
            @click="onCategoryCode(item.code)"
        >
          <div class="active"></div>
          {{item.name}}<i class="count">({{item.count}})</i>
        </el-menu-item>
      </el-submenu>
      <el-menu-item
          :index="item.code"
          v-for="(item, index) in item.children"
          :key="index"
          @click="onCategoryCode(item.code)"
          v-if="type !== 'product'"
      >
        <div class="active"></div>
        {{item.name}}<i class="count">({{item.count}})</i>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: "ProductCategoryVerticalSelect",
  props: ["active","type"],
  computed: {
    items() {
      return this.$store.getters.getProductCategoryOptions();
    }
  },
  methods: {
    onCategoryCode(code) {
      this.$emit("selected", code);
    }
  }
};
</script>

<style lang="less">
li.el-submenu {
  .el-submenu__title {
    font-size: 15px;
    color: #606060;
  }
}
li.el-submenu.is-active.is-opened {
  .el-submenu__title {
    font-weight: bold;
    color: #333333;
  }
}
li.el-menu-item.is-active {
  color: #1b994f;
  font-weight: bold;
}
li.el-submenu > ul > li > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
}
li.el-submenu > ul > li.is-active > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
  background: rgba(27, 153, 79, 1);
  border-radius: 0px 5px 5px 0px;

  position: relative;

  left: -40px;

}
.count{
  font-size: 13px;
  font-style: normal;
}
</style>


<style lang="less" scoped>
.index {
  width: 200px;
  .nav {
    .item {
      background: #3a8b65;

      color: white;

      .children {
        background: white;
        color: #333;
      }
    }
  }
}
</style>

